import { createContext, useContext, useState } from "react";

import ZoomContext from "../zoom/context/zoom-context";
import ZoomVideo from "@zoom/videosdk";
import { apiGetColaboradoresCallCenterEspecialistas } from "../settings/apiConfig";
import { generateVideoToken } from "../zoom/utils/util";
import { getExploreName } from "../zoom/utils/platform";
import { useLogin } from "../context/LoginContext";
import { useRequest } from "./RequestContext";

export const ZoomMeditocContext = createContext();

export function ZoomMeditocProvider(props) {
    const [meetingArgs, setMeetingArgs] = useState(null);
    const { Get } = useRequest();
    const { usuarioSesion } = useLogin();

    const handleChangeMeetingArgs = async (topic, name) => {
        if (meetingArgs) {
            return;
        }

        if (topic && name) {
            const payload = {
                loader: "Actualizando estatus del colaborador...",
                url: apiGetColaboradoresCallCenterEspecialistas + "?piIdUsuarioCGU=" + usuarioSesion.iIdUsuario,
                alert: true,
            };
            const response = await Get(payload);
            console.log(response);
            const sdkKey = "";
            const sdkSecret = "";
            topic = response.Result[0].ZoomData[0].sessionName;
            name = response.Result[0].ZoomData[0].userIdentity;
            const password = response.Result[0].ZoomData[0].password;
            const signature = response.Result[0].ZoomData[0].token;

            setMeetingArgs({
                sdkKey,
                sdkSecret,
                topic,
                name,
                password,
                signature,
            });
        } else {
            return (
                <ZoomMeditocContext.Provider>
                    <ZoomContext.Provider></ZoomContext.Provider>
                </ZoomMeditocContext.Provider>
            );
        }
    };

    const handleClickLeaveMeeting = () => {
        // console.log("Eliminando sala");
        setMeetingArgs(null);
    };

    const zmClient = ZoomVideo.createClient();

    return (
        <ZoomMeditocContext.Provider value={{ meetingArgs, handleChangeMeetingArgs, handleClickLeaveMeeting }}>
            <ZoomContext.Provider value={zmClient}>{props.children}</ZoomContext.Provider>
        </ZoomMeditocContext.Provider>
    );
}

export function useZoomMeditoc() {
    return useContext(ZoomMeditocContext);
}
